import React from "react";
import ContactFormChronicV2 from "./contactFormChronicV2";
import { LocationIco } from "@speedoc/design-assets/build/icons";

const HeroForm = ({ content }) => {
  const {
    header,
    description,
    heroimage,
    formTitle,
    formDescription,
    locationText,
    contactFormV2,
    headerImageSection,
    featureLinearGradient,
    images
  } = content;
  return (
    <div id="HeroForm">
      <div className="wrap">
        <div className="heroImage">
          <img src={heroimage.url} alt="heroImage" />
          <div className="location">
            <LocationIco />
            <div className="locationText">{locationText}</div>
          </div>
          <div className="claimable">
            <div className="headerImageSection">{headerImageSection}</div>
            <div className="imagesContainer">
              {images.map((image, index) => (
                <img src={image.url} alt="" key={index} />
              ))}
            </div>
          </div>
        </div>
        <div className="infoContainer">
          <div className="contentContainer">
            <div className="header">{header}</div>
            <div className="description">{description}</div>
          </div>
          <div className="heroWrap">
            <div className="childHeroImage">
              <img src={heroimage.url} alt="heroImage" />
            </div>
            <div className="heroContainer" style={{ "--linear-bg-form": featureLinearGradient }}>
              <div className="formTitle">{formTitle}</div>
              <div className="formDescription">{formDescription}</div>
              <ContactFormChronicV2 content={contactFormV2} />
              <div className="locationClaimableContainer">
                <div className="childLocation">
                  <LocationIco />
                  <div className="locationText">{locationText}</div>
                </div>
                <div className="childClaimable">
                  <div className="headerImageSection">{headerImageSection}</div>
                  <div className="imagesContainer">
                    {images.map((image, index) => (
                      <img src={image.url} alt="" key={index} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroForm;
